import { memo } from 'react'
import { Collapse } from 'antd'
import type { ClienteItensTypes } from '../../../../../../../../../../services/Cliente'

interface Props {
    cliente: ClienteItensTypes
}

/** Campo (label + valor) do bloco de detalhes do cliente. */
function CampoInfo({ label, valor }: { label: string; valor?: string }) {
    return (
        <div>
            <div style={{ fontSize: '12px', color: '#a0a0a0', fontWeight: 700 }}>{label}</div>
            <div style={{ fontWeight: 500, color: '#262626' }}>{valor || '-'}</div>
        </div>
    )
}

/**
 * Bloco "Detalhes do cliente" (somente leitura), exibido dentro de um Collapse.
 * Memoizado: só re-renderiza quando o objeto `cliente` muda, não a cada tecla nos campos do form.
 */
export const DetalhesCliente = memo<Props>(({ cliente }) => {
    return (
        <Collapse
            defaultActiveKey={[]}
            style={{ backgroundColor: '#d9d9d9', borderRadius: 8, overflow: 'hidden' }}
            items={[
                {
                    key: '1',
                    label: <span style={{ fontWeight: 600 }}>Detalhes do cliente</span>,
                    style: { background: '#fff' },
                    children: (
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '12px 16px' }}>
                            <div style={{ gridColumn: 'span 2' }}>
                                <CampoInfo label='Nome' valor={cliente?.nome} />
                            </div>
                            <CampoInfo label='Endereço' valor={cliente?.endereco as unknown as string} />
                            <CampoInfo label='Num' valor={cliente?.endereco_numero} />
                            <CampoInfo label='Cidade' valor={cliente?.cidade?.nome || 'Cidade não informada'} />
                            <CampoInfo label='CEP' valor={cliente?.cep} />
                        </div>
                    ),
                },
            ]}
        />
    )
})

DetalhesCliente.displayName = 'DetalhesCliente'
